import domready from 'domready';
import branch from './branch';
import optimizely from './optimizely';
import globalPromo from './globalPromoBanner';
import cartDropdown from './cartDropdown';

cartDropdown.init();

domready(() => {
  branch.init();
  globalPromo.init();
  optimizely.init();
});



/** WEBPACK FOOTER **
 ** ./apps/storePages/index.js
 **/